
        import 'AddressLookup.00bfc50.css-module'
        export default {"addressList":"addressList_AddressLookup_00bfc50","addressItem":"addressItem_AddressLookup_00bfc50","selectedAddress":"selectedAddress_AddressLookup_00bfc50","invalidField":"invalidField_AddressLookup_00bfc50"}
    